import { PUBLIC_POCKETBASE_URL } from '$env/static/public';

type IDFields = {
  id: string;
  collectionId: string;
};

export const getFileURL = (record: IDFields, file: string) =>
  `${PUBLIC_POCKETBASE_URL}/api/files/${record.collectionId}/${record.id}/${file}`;

export const formData = (data: object) =>
  Object.entries(data).reduce((formData, [key, value]) => {
    formData.append(key, typeof value === 'object' ? value : `${value}`);
    return formData;
  }, new FormData());
